import { reactive, watch } from 'vue'


interface Settings {
  mute: boolean
  popup: boolean
  pressureColor: boolean
  pressureWeight: boolean
}

const KEY = 'settings'

const makeSettins = ({ mute = false, popup = true, pressureColor = true, pressureWeight = true } = {}): Settings => {
  return reactive({ mute, popup, pressureColor, pressureWeight })
}
const getSettings = (): Settings => {
  try {
    const json = localStorage.getItem(KEY)
    const settings = json ? makeSettins(JSON.parse(json)) : makeSettins()
    localStorage.setItem(KEY, JSON.stringify(settings))
    return settings
  } catch (error) {
    localStorage.removeItem(KEY)
    return makeSettins()
  }
}
const settings = getSettings()
const save = () => localStorage.setItem(KEY, JSON.stringify(settings))

watch(settings, save)

export default settings
